import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import { trans } from '../../../../_providers/Translation'

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png';
import editIcon from '../../../../assets/img/icons/edit.svg';

function Index(props) {

    const [table, setTable] = useState({
        options: null
    });

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        });
    };

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        });
    };

    const handleBackInStock = id => {
        handleCloseMenu();

        props.handleBackInStock(id);
    }

    const handleBackInStockFromStorage = id => {
        handleCloseMenu();

        props.handleBackInStockFromStorage(id);
    }

    const handleHideBackInStock = id => {
        handleCloseMenu();

        props.handleHideBackInStock(id);
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >
                <div className="menu-option" onClick={() => handleBackInStock(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans("random.returnQuantity")}
                </div>
                <div className="menu-option" onClick={() => handleBackInStockFromStorage(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans("random.returnQuantityFromStorage")}
                </div>
                <div className="menu-option" onClick={() => handleHideBackInStock(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans("buttons.hide")}
                </div>
            </Menu>
        </>
    )
}

export default Index;
